import { CustomArray } from "../../../common/CustomArray";
import {RegionItemInfo} from "./RegionItemInfo"

export class  RegionItemInfos extends CustomArray   {

	constructor()
	{

		super();
	}

	 static  GetRegionItemInfos(jsonItems)
		{	
			let curItems=null;
			if(jsonItems==null)return curItems;
			curItems=new RegionItemInfos();
			let tempItem=null;
			for (let tempIndex in jsonItems)
			{	
				tempItem = RegionItemInfo.GetRegionItemInfo(jsonItems[tempIndex]);
				curItems.push(tempItem);
			}
			
			return curItems;
		}

}//end RegionItemInfos

